import React, { forwardRef, useContext, useEffect } from "react"
import MaterialTable from "material-table"
import AddBox from "@material-ui/icons/AddBox"
import ArrowDownward from "@material-ui/icons/ArrowDownward"
import Check from "@material-ui/icons/Check"
import ChevronLeft from "@material-ui/icons/ChevronLeft"
import ChevronRight from "@material-ui/icons/ChevronRight"
import Clear from "@material-ui/icons/Clear"
import DeleteOutline from "@material-ui/icons/DeleteOutline"
import Edit from "@material-ui/icons/Edit"
import FilterList from "@material-ui/icons/FilterList"
import FirstPage from "@material-ui/icons/FirstPage"
import LastPage from "@material-ui/icons/LastPage"
import Remove from "@material-ui/icons/Remove"
import SaveAlt from "@material-ui/icons/SaveAlt"
import Search from "@material-ui/icons/Search"
import ViewColumn from "@material-ui/icons/ViewColumn"
import { postToTable, patchTable, deleteFromTable } from "../api/apiCalls"
import { UserContext } from "../contexts/UserContext"
import { HistoryContext } from "../contexts/HistoryContext"
import { MessagingContext } from "../contexts/MessagingContext"
import Select from "@material-ui/core/Select"
import MenuItem from "@material-ui/core/MenuItem"
import { isEqual, uniq, filter, groupBy, pickBy, countBy, toNumber } from "lodash"

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
}

const StandardsTable = ({
  data,
  columns,
  title,
  value,
  editable,
  callback,
  actions,
  actionsColumnIndex = 0,
}) => {
  const [state, setState] = React.useState({ data: [] })
  const [hasBadMarketName, setHasBadMarketName] = React.useState(false)
  const { user } = useContext(UserContext)
  const { fetchHistory } = useContext(HistoryContext)
  const { addWarningMessage } = useContext(MessagingContext)

  columns.forEach((el) => {
    if (el.lookup) {
      let retObj = {}
      const parsedObj = el.lookup

      if (title === "Conversion Factors" && el.title === "Megafile Market") {
        // let keys = Object.keys(el.lookup);
        // let vals = Object.values(el.lookup);
        //
        // let encounteredIndices = {};
        // let foundArray = [];
        //
        //
        // for(let i = 0; i < vals.length; i++)
        //   if (encounteredIndices[vals[i]]) {
        //     console.log(i); // Or add to some array if you wish
        //     foundArray.push(Number(i))
        //   } else {
        //     encounteredIndices[vals[i]] = 1;
        //   }
        //
        // for(let i = 0; i < keys.length; i++) {
        //   console.log(keys[i], '>>>>>>>   ', foundArray.indexOf(Number(keys[i])))
        // }
      }

      let sorted = Object.entries(parsedObj).sort((a, b) => a[1].localeCompare(b[1]))

      let editComponent = (props) => {
        return (
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={props.value}
            onChange={(e) => {
              console.log(title, el.title)
              console.log(" PROPS >>>>>>   ", props)
              if (title === "Readers Per Copy" && el.title === "Rule Description") {
                var tempData = { ...props.rowData }
                let res = e.target.value
                if (res === "BY ESTIMATE ONLY") {
                  tempData.rule_order = 3
                }
                if (res === "BY PUBLICATION AND BY ESTIMATE") {
                  tempData.rule_order = 1
                }
                if (res === "BY PUBLICATION ONLY") {
                  tempData.rule_order = 2
                }
                if (res === "BY MEDIA TYPE ONLY") {
                  tempData.rule_order = 4
                }
                tempData.rule_description = res
                props.onRowDataChange(tempData)
              } else if (title === "Readers Per Copy" && el.title === "Media Type") {
                var tempData2 = { ...props.rowData }
                let res2 = e.target.value
                tempData2.media_type = res2
                console.log(" .............  TD2 ...  ", tempData2, res2)
                props.onRowDataChange(tempData2)
              } else {
                props.onChange(e.target.value)
              }
            }}
            style={{ width: "100%" }}
          >
            {sorted.map((keyVal) => {
              return (
                <MenuItem key={keyVal[0]} value={keyVal[0]}>
                  {keyVal[1].toUpperCase()}
                </MenuItem>
              )
            })}
          </Select>
        )
      }

      let FilterComponent = (props) => {
        return (
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={props.value}
            onChange={(event) => {
              //console.log(" VALUE TO BE SAVED ...   ", e.target.value);
              console.log(
                props.value,
                "  CHANGED >>>>>>>>>>>>>>>  ",
                event.target.value
              )
              props.onFilterChanged(props.columnDef.tableData.id, event.target.value)
            }}
            style={{ width: "100%" }}
          >
            {sorted.map((keyVal) => {
              return (
                <MenuItem key={keyVal[0]} value={keyVal[0]}>
                  {keyVal[1].toUpperCase()}
                </MenuItem>
              )
            })}
          </Select>
        )
      }

      el.editComponent = editComponent

      if (el.title === "Megafile Market") {
        el.filterComponent = (props) => <FilterComponent {...props} />
      }
    }
  })

  const appendDemoData = (rows) => {
    rows.map((row) => {
      if (row.label.startsWith("Adults")) row.label = row.label + " *"
    })
    return rows
  }

  useEffect(() => {
    setState({
      data: title === "Demo" ? appendDemoData(data) : data,
    })
  }, [])

  const verifyMarketName = (id) => {
    let [marketList] = columns.filter((col) => col.title === "Megafile Market")
    let keys = Object.keys(marketList.lookup)
    const ind = keys.indexOf(id.toString())
    let returnVal = ind === -1 && title === "Conversion Factors"
    return returnVal
  }

  if (state.data) {
    const { data } = state

    const ignoreArray = [
      "id",
      "createdAt",
      "updatedAt",
      "tableData",
      "active",
      "media_type",
      "a25_49",
      "a25_54",
      "digital_social_custom_nielsen_dmas",
      "national_local_audio_nielsen_msas",
      "national_local_tv_nielsen_dmas",
      "ooh_nielsen_dmas",
      "print_custom_nielsen_dmas",
      "tvi_nielsen_dmas",
      "rule_order",
      "rule_description",
      "factor",
    ]

    let newCols = columns

    if (title === "Media Channel/Subchannel")
      newCols = columns.map(function (el) {
        // console.log("el ", el.title)
        let o = Object.assign({}, el)
        if (el.title === "Channel") {
          o.title = "Media Channel"
        }
        if (el.title === "Media Group") {
          o.title = "Team"
        }
        return o
      })

    if (title === "Readers Per Copy") {
      newCols = columns.map(function (el) {
        let o = Object.assign({}, el)
        if (el.title === "Rule Order") {
          o.editable = "never"
        }
        return o
      })
    }

    let isDuplicate = false
    let hasMissingDataCols = true

    const isEmptyValue = (val) => {
      console.log(" VAL", val, "end Val")
      return (
        val == 0 ||
        val == "ANY" ||
        val == "" ||
        val == "-" ||
        val == undefined ||
        val == null
      )
    }

    console.log(" user.accessLevel ", user.accessLevel)

    return (
      <div>
        {title === "Demo" && (
          <div style={{ fontSize: "12px", marginBottom: "10px" }}>
            * This Demo is permitted for Linear TV and Audio teams only
          </div>
        )}

        {hasBadMarketName && (
          <div style={{ fontSize: "12px", marginBottom: "10px", color: "red" }}>
            Please fix the Megafile Market titles on the highlighted rows.
          </div>
        )}
        <MaterialTable
          title={title}
          data={data}
          columns={newCols}
          icons={tableIcons}
          options={{
            search: true,
            exportButton: true,
            pageSize: 10,
            filtering: true,
            sorting: true,
            exportAllData: true,
            actionsColumnIndex,
            rowStyle: (rowData) => {
              if (rowData.market_id && verifyMarketName(rowData.market_id)) {
                setHasBadMarketName(true)
                const rowBackgroundColor = "rgb(228 236 255)"
                return { backgroundColor: rowBackgroundColor }
              }
            },
          }}
          actions={actions}
          editable={
            editable.includes(user.accessLevel) && {
              onRowAdd: async (newData) => {
                if (title === "Readers Per Copy") {
                  newData.estimate_id = newData.estimate_id || "0"
                  newData.media_type = newData.media_type || "0"
                  newData.product = newData.product || "0"
                  newData.publication_id = newData.publication_id || "0"
                  newData.publication_name = newData.publication_name || "ANY"
                }

                if (title === "Conversion Factors") {
                  newData.a25_49 = newData.a25_49 || null
                  newData.a25_54 = newData.a25_54 || null
                }

                console.log(
                  " >>>>>>>>>>>>>> TITLE >>>>>>>>>>>>>>>>>>>>      ",
                  title
                )

                if (title !== "Readers Per Copy") {
                  // TODO - clean this nest of garbage up.  Scope creep kept adding new unique rules per
                  //  tables every week as HMI ads to their prod app every week.  The result is a mess
                  //  of conditional rules per column, table, page type or card.

                  isDuplicate = true

                  if (!data.length) {
                    isDuplicate = false
                  }

                  for (let i = 0; i < data.length; i++) {
                    let row = data[i]
                    isDuplicate = true

                    if (title === "Markets") {
                      newData.raw = newData.raw.toUpperCase()
                      newData.megafile_markets = newData.megafile_markets.toUpperCase()
                    }

                    for (let key of Object.keys(row)) {
                      if (row[key] === undefined || row[key] === "") row[key] = null

                      if (ignoreArray.indexOf(key) < 0) {
                        console.log(
                          key,
                          ": ",
                          row[key],
                          " is being compared to ",
                          newData[key],
                          row[key] != newData[key]
                        )
                        console.log(" >> ", typeof row[key], typeof newData[key])
                        if (
                          typeof row[key] === "string" &&
                          typeof newData[key] === "string"
                        ) {
                          if (row[key].toUpperCase() != newData[key].toUpperCase()) {
                            console.log(" STRINGS DO NOT MATCH - FALSE")
                            isDuplicate = false
                          }
                        } else {
                          if (row[key] != newData[key]) {
                            console.log(" ITEMS DO NOT MATCH - FALSE")
                            isDuplicate = false
                          }
                        }
                      }
                    }

                    if (isDuplicate) {
                      console.log(" IsDuplicate >>> ", isDuplicate)
                      break
                    }
                  }

                  if (title === "Conversion Factors") {
                    hasMissingDataCols =
                      isEmptyValue(newData.subchannel_id) ||
                      isEmptyValue(newData.market_id) ||
                      isEmptyValue(newData.buy_demo_id)

                    if (!hasMissingDataCols) {
                      hasMissingDataCols =
                        isEmptyValue(newData.a25_49) && isEmptyValue(newData.a25_54)
                    }
                  }

                  hasMissingDataCols = false
                } else if (title !== "Conversion Factors") {
                  hasMissingDataCols =
                    isEmptyValue(newData.estimate_id) &&
                    isEmptyValue(newData.media_type) &&
                    isEmptyValue(newData.product) &&
                    isEmptyValue(newData.publication_id) &&
                    isEmptyValue(newData.publication_name)
                }

                if (isDuplicate) {
                  addWarningMessage(
                    "Duplicate Record Notice",
                    "This record already exists."
                  )
                } else if (hasMissingDataCols && value === "readersforcopy") {
                  addWarningMessage(
                    "Minimum Amount Of Data Not Reached",
                    'You must enter at least one non-"ANY" or blank value into one of the following fields: Publication Name, Publication ID, Media Type, Estimate ID or Product.'
                  )
                } else if (hasMissingDataCols && title === "Conversion Factors") {
                  addWarningMessage(
                    "Minimum Amount Of Data Not Reached",
                    "You must enter data for Subchannel, Magafile Market, Buy Demo, and either A25-49 or A25-54."
                  )
                } else {
                  let { id } = await postToTable(user, value, newData)
                    .then((response) => {
                      if (response.ok) {
                        return response.json()
                      }
                    })
                    .then((data) => data)
                  return new Promise((resolve) => {
                    setTimeout(() => {
                      resolve()
                      setState((prevState) => {
                        newData = { id, ...newData }
                        const data = [...prevState.data]
                        data.push(newData)
                        return { ...prevState, data }
                      })
                    }, 600)
                  })
                }
              },
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve) => {
                  setHasBadMarketName(false)
                  setTimeout(() => {
                    resolve()

                    if (title === "Conversion Factors") {
                      newData.a25_49 = newData.a25_49 || null
                      newData.a25_54 = newData.a25_54 || null
                    }

                    if (title === "Readers Per Copy") {
                      newData.estimate_id = newData.estimate_id || "0"
                      newData.media_type = newData.media_type || "0"
                      newData.product = newData.product || "0"
                      newData.publication_id = newData.publication_id || "0"
                      newData.publication_name = newData.publication_name || "ANY"
                    }

                    if (title === "Markets") {
                      newData.raw = newData.raw.toUpperCase()
                      newData.megafile_markets = newData.megafile_markets.toUpperCase()
                    }

                    let dataChanged = true
                    let isDuplicate = false

                    if (title !== "Readers Per Copy") {
                      isDuplicate = true
                      console.log(" OLD AND NEW :    ", oldData, newData)
                      //  we are temporarily NOT checking the Readers Per Copy table for dupes
                      if (oldData.active !== newData.active) {
                        // active has changed.  need to see if key columns have changed to ensure no duplicates
                        let tempOldData = {}
                        let tempNewData = {}

                        tempOldData.tableData = oldData.tableData
                        tempOldData.active = oldData.active
                        tempNewData.tableData = newData.tableData
                        tempNewData.active = newData.active

                        delete oldData.tableData
                        delete oldData.active
                        delete newData.tableData
                        delete newData.active

                        dataChanged = !isEqual(oldData, newData)
                        isDuplicate = dataChanged
                        oldData.tableData = tempOldData.tableData
                        oldData.active = tempOldData.active
                        newData.tableData = tempNewData.tableData
                        newData.active = tempNewData.active
                      }

                      if (dataChanged) {
                        for (let i = 0; i < data.length; i++) {
                          let row = data[i]
                          isDuplicate = true

                          for (let key of Object.keys(row)) {
                            if (row[key] === undefined || row[key] === "")
                              row[key] = null

                            if (ignoreArray.indexOf(key) < 0) {
                              // console.log(key, ': ', row[key],  ' is being compared to ', newData[key])
                              // console.log(" >> ", typeof row[key], typeof newData[key] )

                              //console.log(row[key], ': ', typeof row[key], typeof newData[key])

                              if (
                                typeof row[key] === "string" &&
                                typeof newData[key] === "string"
                              ) {
                                //console.log(row[key].toUpperCase(),  newData[key].toUpperCase())
                                if (
                                  row[key].toUpperCase() !=
                                  newData[key].toUpperCase()
                                ) {
                                  isDuplicate = false
                                }
                              } else {
                                if (row[key] != newData[key]) {
                                  isDuplicate = false
                                }
                              }
                            }
                          }
                          if (isDuplicate) {
                            addWarningMessage(
                              "Duplicate Record Notice",
                              "This record already exists."
                            )
                            new Promise((resolve) => {
                              setTimeout(() => {
                                resolve()
                                setState((prevState) => {
                                  const data = [...prevState.data]
                                  //data.splice(data.indexOf(newData), 1)
                                  //deleteFromTable(user, value, newData)
                                  return { ...prevState, data }
                                })
                              }, 600)
                            })
                            break
                          }
                        }
                      }
                    } else {
                      hasMissingDataCols =
                        isEmptyValue(newData.estimate_id) &&
                        isEmptyValue(newData.media_type) &&
                        isEmptyValue(newData.product) &&
                        isEmptyValue(newData.publication_id) &&
                        isEmptyValue(newData.publication_name) &&
                        title !== "Conversion Factors"
                      if (hasMissingDataCols) {
                        addWarningMessage(
                          "Minimum Amount Of Data Not Reached",
                          "You must enter at least one non-any value into one of the following: Publication Name, Publication ID, Media Type, Estimate ID or Product."
                        )
                        new Promise((resolve) => {
                          setTimeout(() => {
                            resolve()
                            setState((prevState) => {
                              const data = [...prevState.data]
                              //data.splice(data.indexOf(newData), 1)
                              //deleteFromTable(user, value, newData)
                              return { ...prevState, data }
                            })
                          }, 600)
                        })
                      }
                    }

                    if (title === 'LOB/Brand (Product)') {
                      hasMissingDataCols = false;
                    }

                    if (title === "Demo") {
                      hasMissingDataCols =
                        isEmptyValue(newData.label) ||
                        isEmptyValue(newData.buy_demo_id)
                    }

                    if (title === "Media Channel/Subchannel") {
                      hasMissingDataCols = false
                    }

                    if (title === "Markets") {
                      hasMissingDataCols =
                        isEmptyValue(newData.raw) ||
                        isEmptyValue(newData.megafile_markets)
                    }

                    console.log(" OLD / NEW DATA  CHECK  ::::::::   ", hasMissingDataCols,  !isDuplicate, oldData)

                    if (!hasMissingDataCols && !isDuplicate && oldData) {
                      console.log(" SAVING .......................")
                      setState((prevState) => {
                        const data = [...prevState.data]
                        data[data.indexOf(oldData)] = newData
                        patchTable(user, value, newData).then(() => {
                          // console.log(callback)
                          fetchHistory(user)
                          if (callback) {
                            callback()
                          }
                        })
                        return { ...prevState, data }
                      })
                    }
                  }, 600)
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve) => {
                  setHasBadMarketName(false)
                  setTimeout(() => {
                    resolve()
                    setState((prevState) => {
                      const data = [...prevState.data]
                      data.splice(data.indexOf(oldData), 1)
                      deleteFromTable(user, value, oldData)
                      return { ...prevState, data }
                    })
                  }, 600)
                }),
            }
          }
        />
      </div>
    )
  }
  return <div></div>
}

export default StandardsTable
